<template>
	<div id="login">
		<div class="login-wrapper" v-show="tokenIsValid">
			<form class="login-form" method="POST" v-on:submit.prevent="resetPassword">
				<div class="login-container">
					<div class="login-header">
						<Logo />
					</div>
					<div class="form-fields">
						<h1 class="title is-4">Reset Password</h1>
						<p>Please confirm you desired password below.</p>
						<b-notification
							type="is-danger"
							v-if="error"
							:closable="false">
							{{ error }}
						</b-notification>
						<b-field label="Password"
						         :type="feedback.password.type"
						         :message="feedback.password.message">
							<b-input v-model="input.password"
							         type="password"
							         ref="password"
							         password-reveal>
							</b-input>
						</b-field>
						<b-field label="Password (again)"
						         :type="feedback.password_confirmation.type"
						         :message="feedback.password_confirmation.message">
							<b-input v-model="input.password_confirmation"
							         type="password"
							         ref="password_confirmation"
							         password-reveal>
							</b-input>
						</b-field>
					</div>
					<div class="login-footer">
						<button class="button is-primary has-icon"
						        :disabled="processing"
						        type="submit">
							<b-icon icon="key"></b-icon>
							<span class="button-label">Change Password</span>
						</button>
					</div>
				</div>
			</form>
			<p class="login-copyright">&copy; {{ new Date().getFullYear() }} &ndash; {{ title }}. All rights reserved.</p>
		</div>
	</div>
</template>

<style lang="scss">

</style>

<script>
import Logo from './Icons/Logo'
import { AUTH_RESET, AUTH_VALIDATE_RESET_TOKEN } from '../store/actions/auth'
import { mapGetters, mapMutations } from 'vuex'

export default {
  components: {
    Logo
  },
  data () {
    return {
      title: process.env.NAME,
      input: {
        email: '',
        password: '',
        password_confirmation: '',
        remember: false
      },
      feedback: {
        'password': {
          'type': '',
          'message': ''
        },
        'password_confirmation': {
          'type': '',
          'message': ''
        }
      },
      error: '',
      processing: false,
      token: this.$route.params.token,
      tokenIsValid: false
    }
  },
  computed: mapGetters({
    isAuthenticated: 'isAuthenticated'
  }),
  methods: {
    ...mapMutations([
      'setPageTitle'
    ]),
    validateToken () {
      const resetToken = this.token
      this.$store.dispatch(AUTH_VALIDATE_RESET_TOKEN, resetToken)
        .then(response => {
          this.tokenIsValid = true
          this.$refs.password.focus()
          this.email = response.data.email
        })
        .catch(err => {
          if (err.hasOwnProperty('response')) {
            this.$buefy.toast.open({
              message: err.response.data.message,
              type: 'is-danger'
            })
          }

          this.$router.push({ name: 'login' })
        })
    },
    // TODO: checkbox when passwords match while typing
    validatePasswords () {
      this.error = ''
      this.feedback.password.type = ''
      this.feedback.password_confirmation.type = ''

      if (!this.input.password) {
        this.feedback.password.type = 'is-danger'
        this.processing = false
        return false
      }

      if (!this.input.password_confirmation) {
        this.feedback.password_confirmation.type = 'is-danger'
        this.processing = false
        return false
      }

      if (this.input.password !== this.input.password_confirmation) {
        this.feedback.password_confirmation.type = 'is-danger'
        this.feedback.password.type = 'is-danger'
        this.error = 'The passwords you entered do not match'
        this.processing = false
        return false
      }

      return true
    },
    resetPassword () {
      this.processing = true
      if (this.validatePasswords()) {
        const formData = {
          email: this.input.email,
          password: this.input.password,
          password_confirmation: this.input.password_confirmation,
          token: this.token
        }
        this.$store.dispatch(AUTH_RESET, formData).then(response => {
          this.$buefy.toast.open({
            duration: 6000,
            message: response.message,
            type: 'is-success'
          })

          this.$router.push({ name: 'login' })
        }).catch(error => {
          this.processing = false

          if (error.hasOwnProperty('response')) {
            if (error.response.data.response === 'error') {
              this.error = error.response.data.message
              this.input.password = ''
              this.$refs.password.focus()
            }

            if (error.response.data.response === 'validationError') {
              let fields = error.response.data.data
              for (const prop in fields) {
                if (fields.hasOwnProperty(prop)) {
                  if (this.feedback.hasOwnProperty(prop)) {
                    this.feedback[prop].type = 'is-danger'
                    this.feedback[prop].message = fields[prop]
                  }
                }
              }
            }
          } else {
            this.$buefy.toast.open({
              message: error.toString(),
              type: 'is-danger'
            })
          }
        })
      }
    }
  },
  mounted () {
    this.setPageTitle('Password Reset')
    this.validateToken()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ResetPassword.vue